export default __webpack_public_path__ + "static/media/bullet.8d1f1d07.svg";